import { Button } from "@faire/web/slate/Button";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { BackToDestination } from "./types";
import { useBackToCtaContextMap } from "./useBackToCtaContextMap";
export var BackToCta = function BackToCta(_ref) {
  var destination = _ref.destination,
    variant = _ref.variant,
    onClick = _ref.onClick;
  var _useBackToCtaContextM = useBackToCtaContextMap(),
    backToCtaContextMap = _useBackToCtaContextM.backToCtaContextMap;
  var backToCtaContext = backToCtaContextMap[destination !== null && destination !== void 0 ? destination : BackToDestination.FAIRE];
  if (!(backToCtaContext !== null && backToCtaContext !== void 0 && backToCtaContext.label)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(BackToButton, {
    variant: variant,
    onClick: onClick,
    linkTo: backToCtaContext === null || backToCtaContext === void 0 ? void 0 : backToCtaContext.linkTo
  }, backToCtaContext === null || backToCtaContext === void 0 ? void 0 : backToCtaContext.label);
};
var BackToButton = styled(Button).withConfig({
  displayName: "BackToCta__BackToButton"
})(["", "{width:fit-content;}", "{width:100%;}"], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile);